import React, { useMemo } from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { useBrand } from "../context/BrandContext";

/**
 * MUI palette + typography follow club branding (BrandContext).
 * Ensures color="primary", sx={{ color: "primary.main" }}, etc. match --brand-*.
 */
export function MuiBrandTheme({ children, brand }) {
  const { themeMode } = useBrand();

  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: themeMode || "light",
          primary: {
            main: brand?.color_primary || "#0877BC",
            dark: brand?.color_primary_dark || "#065a8f",
            light: brand?.color_primary_light || "#0a8cd8",
          },
          secondary: {
            main: brand?.color_secondary || "#46528b",
          },
          background: {
            default:
              themeMode === "light"
                ? brand?.color_background || "#f4f5f6"
                : "#121214",
            paper:
              themeMode === "light"
                ? brand?.color_surface || brand?.color_background || "#ffffff"
                : "#1e1e24",
          },
          text: {
            primary:
              themeMode === "light"
                ? brand?.color_text_primary || "#1e1e1e"
                : "#ffffff",
            secondary:
              themeMode === "light"
                ? brand?.color_text_secondary || "#838383"
                : "#a1a1aa",
          },
        },
        typography: {
          fontFamily: [
            brand?.font_family || "Poppins",
            "Roboto",
            "Helvetica Neue",
            "Arial",
            "sans-serif",
          ].join(","),
        },
        components: {
          MuiButton: {
            styleOverrides: {
              containedPrimary: {
                "&:hover": {
                  backgroundColor: brand?.color_primary_dark || "#065a8f",
                },
              },
            },
          },
        },
      }),
    [
      brand?.color_primary,
      brand?.color_primary_dark,
      brand?.color_primary_light,
      brand?.color_secondary,
      brand?.color_text_primary,
      brand?.color_text_secondary,
      brand?.color_background,
      brand?.font_family,
      themeMode,
    ]
  );

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
